import { createSelector } from 'reselect'

import featureFlagsSelectorCreator from '../feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.STUDENT_LIBRARY,
])

const loginSelector = state => state.login
const qsSelector = state => state.qs
const uiSelector = state => state.ui
const userSelector = state => state.user

export default createSelector(
	[loginSelector, qsSelector, uiSelector, userSelector, featureFlagsSelector],
	(loginSelectorData, qsSelectorData, uiSelectorData, userSelectorData, featureFlags) => {

		const isInIframe = uiSelectorData.isInIframe
		const isMsft = qsSelectorData.isMsft === '1'
		const isTeamsDesktopApp = qsSelectorData.teamsDesktopApp === '1'
		const canActAsStudent = !isMsft && qsSelectorData.from_google_slides !== '1'
		const shouldHideGoogleSso = isMsft || isTeamsDesktopApp
		const shouldHideOfficeSso = isTeamsDesktopApp
		const shouldShowDividerLine = canActAsStudent
		|| !shouldHideGoogleSso || !shouldHideOfficeSso
		const shouldShowStudentSso = featureFlags[featureFlagsTypes.STUDENT_LIBRARY]

		return {
			authenticationFailed: loginSelectorData.authenticationFailed,
			fromLTI: qsSelectorData.fromLTI,
			isInIframe,
			canActAsStudent,
			shouldOpenInNewTab: qsSelectorData.from_google_slides === '1',
			shouldHideHeaderLogo: qsSelectorData.from_google_slides === '1',
			shouldHideGoogleSso,
			shouldHideOfficeSso,
			shouldShowDividerLine,
			canLinkToHome: !isMsft && qsSelectorData.from_google_slides !== '1',
			isUserLogged: userSelectorData.logged,
			email: loginSelectorData.email,
			shouldShowStudentSso,
		}
	}
)
